export function getParams(search) {
  let params = {};
  search.replace('?', '').split('&').map(i => {
    let kv = i.split('=');
    if (kv[0]) params[kv[0]] = kv[1];
    return kv;
  });
  return params;
}